import { directiveSettings } from '../../utils/parse';
import { onResize, onScroll, getScrollTop } from '../../utils/window';
import { frame } from '../../utils/drawing';
/**
 * @module directives/scroll/sticky
 */

/**
 * Sticks an element top the top of the screen.
 */
export default function stickyDirective() {

  // Add sticky behaviour
  document.querySelectorAll('[data-sw-sticky]').forEach(element => {
    const data = element.getAttribute('data-sw-sticky'),
    settings = directiveSettings(data, {
      name: '',
      offset: 0,
      position: 'before'
    }, 'name');

    // Find or create/insert filler elememt
    let fixed = false,
      filler = settings.name ? document.querySelector(`[data-sw-sticky-filler='${settings.name}']`) : null;

    if (!filler) {
      filler = document.createElement("div");
      filler.setAttribute("data-sw-sticky-filler", settings.name);
      filler.style.display = 'none';
      element.parentElement.insertBefore(filler, settings.position === 'before' ? element : element.nextSibling);
    }

    // Sticky functions
    const fillerSize = _ => {
      filler.style.height = `${element.offsetHeight}px`;
    };

    const stickyScroll = _ => {
      const scrollTop = getScrollTop();
      if (fixed) {
        const fillerTop = filler.offsetTop + settings.offset;
        if (scrollTop <= fillerTop) {
          fixed = false;
          fixSticky(false);
        }
      } else {
        const stickyTop = filler.offsetTop + settings.offset;
        if (scrollTop > stickyTop) {
          fixed = true;
          fixSticky(true);
        }
      }
    };

    const fixSticky = fix => {
      if (fix) {
        filler.style.display = '';
        element.classList.add('is-stuck');
        element.classList.remove('is-unstuck');
      } else {
        filler.style.display = 'none';
        element.classList.remove('is-stuck');
        element.classList.add('is-unstuck');
      }
    };

    // Init/events
    window.addEventListener('load', () => {
      frame(fillerSize);
      frame(stickyScroll);
      onResize(_ => {
        fillerSize();
        stickyScroll();
      });
      onScroll(stickyScroll);
      frame(_ => fixSticky(fixed));
    });
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/sticky.js